import Card from "./Card";
import React, { useState } from "react";
import styled from "styled-components";
import { getFilenamePrefix } from "utils/files";
import { COLORS } from "utils/styles";
import { Dropdown } from "react-bootstrap";
import { MainNavToggle } from "components/Nav/components";
import Picture from "components/Picture";

const TopChannels = "Top Channels";
const TopMusic = "Top Music Genres";
const TopTags = "Top Tags";

const TopChannelsPng = "/images/topchannels-export.png";
const TopMusicPng = "/images/topmusic-export.png";
const TopTagsPng = "/images/toptags-export.png";

const Container = styled.div`
  max-width: 80rem;
  margin: 0 auto;
`;

const Title = styled.h2`
  display: flex;
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
`;

const TitleText = styled.span.attrs(() => ({
  className: "mabry-regular",
}))`
  display: block;
  flex-grow: 1;
`;

const SpiderGraph = styled.div`
  width: 100%;
`;

const Caption = styled.p`
  padding-top: 25px;
`;

const StyledPicture = styled(Picture)`
  img {
    width: 100%;
  }
`;

const Toggle = styled(MainNavToggle)`
  background-color: ${COLORS.WHITE};
  filter drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.1));
`;

export default function TopYoutubeCard() {
  const [currentGraph, setGraph] = useState(TopChannelsPng);
  const [selectedGraphTitle, selectGraph] = useState(TopChannels);
  const [expandFilters, setExpandFilters] = useState(false);

  const renderImage = (src, alt) => {
    return <StyledPicture image={src} imageAld={alt} />;
  };

  const renderCurrentGraph = () => {
    switch (currentGraph) {
      case TopChannelsPng:
        return renderImage(
          TopChannelsPng,
          "A word spider depicting top Youtube channels."
        );
      case TopMusicPng:
        return renderImage(
          TopMusicPng,
          "A word spider depicting top music genres."
        );
      case TopTagsPng:
        return renderImage(
          TopTagsPng,
          "A word spider depicting top tags on Youtube."
        );
    }
  };

  const onOptionClicked = (value) => () => {
    selectGraph(value);
    switch (value) {
      case TopChannels:
        return setGraph(TopChannelsPng);
      case TopMusic:
        return setGraph(TopMusicPng);
      case TopTags:
        return setGraph(TopTagsPng);
    }
  };

  const CustomToggle = React.forwardRef(
    ({ className, children, onClick }, ref) => {
      return (
        <Toggle
          className={className}
          ref={ref}
          onClick={(e) => {
            e.preventDefault();
            onClick(e);
          }}
        >
          {children}
        </Toggle>
      );
    }
  );

  const renderDropdown = () => {
    return (
      <Dropdown
        onClick={() => {
          setExpandFilters(!expandFilters);
        }}
      >
        <Dropdown.Toggle as={CustomToggle}>
          {selectedGraphTitle}
          <i className="material-icons-round md-dark md-18">
            {expandFilters ? "expand_less" : "expand_more"}
          </i>
        </Dropdown.Toggle>
        <Dropdown.Menu alignRight>
          <Dropdown.Item onClick={onOptionClicked(TopChannels)}>
            {TopChannels}
          </Dropdown.Item>
          <Dropdown.Item onClick={onOptionClicked(TopMusic)}>
            {TopMusic}
          </Dropdown.Item>
          <Dropdown.Item onClick={onOptionClicked(TopTags)}>
            {TopTags}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  return (
    <Container>
      <Card>
        <Title>
          <TitleText>Cultural Domains on YouTube</TitleText>
          <Dropdown>{renderDropdown()}</Dropdown>
        </Title>

        <SpiderGraph currentGraph={currentGraph}>
          {renderCurrentGraph()}
        </SpiderGraph>

        <Caption>
          Bigger words in the chart are more common overall. Words that appear
          in the center of a quadrant 'belong' to that group. Words close to an
          axis are shared by two groups. All words included here are from media
          consumed during summer 2020.
        </Caption>
      </Card>
    </Container>
  );
}
